export const shouldPrefillRelationship = (currentValue, suggestion) => {
  if (!suggestion) return false;
  const current = (currentValue || "").trim();
  return current === "";
};
